<template>
  <div>
    <!-- 顶部tab切换 -->
    <div class="function-nav">
      <div class="nav-tabs">
        <span v-for="tab in tabs" :key="tab.label" class="tab" :class="{active: activeTab === tab.label}" @click="switchTab(tab)">{{ tab.label }}</span>
      </div>
      <div class="refresh-btn">
        <button @click="onRefresh" style="background:#4caf50;color:#fff;border:none;padding:4px 16px;border-radius:4px;">刷新</button>
      </div>
    </div>
    <!-- 筛选区 -->
    <div class="search-section search-section-new">
      <form class="search-form-2x2">
        <div class="form-fields">
          <div class="form-item">
            <label>所属厂区：</label>
            <select class="form-input" v-model="query.park">
              <option value="">全部</option>
              <option v-for="area in options.park" :key="area" :value="area">{{ area }}</option>
            </select>
          </div>
          <div class="form-item">
            <label>所属楼号：</label>
            <select class="form-input" v-model="query.building">
              <option value="">全部</option>
              <option v-for="building in options.building" :key="building" :value="building">{{ building }}</option>
            </select>
          </div>
          <div class="form-item">
            <label>所属楼层：</label>
            <select class="form-input" v-model="query.floor">
              <option value="">全部</option>
              <option v-for="floor in options.floor" :key="floor" :value="floor">{{ floor }}</option>
            </select>
          </div>
          <!-- <div class="form-item">
            <label>所属公司：</label>
            <select class="form-input" v-model="query.company">
              <option value="">全部</option>
              <option v-for="company in options.company" :key="company" :value="company">{{ company }}</option>
            </select>
          </div> -->
          <div class="form-item">
            <label>开始日期：</label>
            <input class="form-input" type="datetime-local" v-model="query.startDate" placeholder="" />
          </div>
          <div class="form-item">
            <label>结束日期：</label>  
            <input class="form-input" type="datetime-local" v-model="query.endDate" placeholder="" />
          </div>
          <div class="form-item">
            <label>设备编号：</label>
            <input class="form-input" v-model="query.fac_id" placeholder="输入设备编号" />
          </div>
        </div>
        <div class="form-btns">
          <button type="button" class="search-btn-green" @click="onSearch">搜索</button>
          <button type="button" class="search-btn-green" @click="printData">打印</button>
          <!-- <button type="button" class="clear-btn" @click="onClear">清空</button> -->
        </div>
      </form>
    </div>
    <!-- 新增按钮 -->
    <div style="margin: 16px 0 8px 8px;">
      <button class="search-btn-green" @click="showAddFormWithDefaults" style="background:#4caf50;">
        <span style="font-size:18px;font-weight:bold;"></span> 新增表具
      </button>
    </div>
    <!-- 表格 -->
    <div class="data-section">
      <div class="table-container">
        <table class="data-table">
          <thead>
            <tr>
              <th>序号</th>
              <th>设备编号</th>
              <th>设备名称</th>
              <th>安装日期</th>
              <th>安装位置</th>
              <th>设备厂家</th>
              <th>所属公司</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="8" style="text-align:center;color:#bbb;">数据加载..</td>
            </tr>
            <tr v-else-if="pagedList.length === 0">
              <td colspan="8" style="text-align:center;color:#bbb;">暂无数据</td>
            </tr>
            <template v-if="pagedList.length > 0">
              <tr v-for="(item, idx) in pagedList" :key="item.id">
                <td>{{ (page-1)*pageSize + idx + 1 }}</td>
                <td>{{ item.deviceNumber }}</td>
                <td>{{ item.deviceName }}</td>
                <td>{{ item.installDate }}</td>
                <td>{{ item.installLocation }}</td>
                <td>{{ item.manufacturer }}</td>
                <td>{{ item.company }}</td>
                <td>
                  <div style="display:flex;gap:8px;white-space:nowrap;">
                    <button class="search-btn-green" style="padding:4px 8px;font-size:14px;" @click="showDeviceDetail(item)">详情</button>
                    <button class="search-btn-green" style="padding:4px 8px;font-size:14px;" @click="showDeviceEdit(item)">编辑</button>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <!-- 分页 -->
      <div class="pagination">
        <button class="page-btn" :disabled="page===1" @click="page=1;loadData()">«</button>
        <button class="page-btn" :disabled="page===1" @click="page--;loadData()">&lt;</button>
        <span v-for="p in displayPages" :key="p">
          <button class="page-btn" :class="{active:page===p}" @click="page=p;loadData()">{{p}}</button>
        </span>
        <button class="page-btn" :disabled="page===totalPages" @click="page++;loadData()">&gt;</button>
        <button class="page-btn" :disabled="page===totalPages" @click="page=totalPages;loadData()">»</button>
        <div class="page-jump">
          <input type="text" v-model="pageInput" style="width:50px;" />
          <button class="jump-btn" @click="jumpPage">跳转</button>
        </div>
      </div>
    </div>
    
    <!-- 新增/编辑表单弹窗 -->
    <div v-if="showAddForm" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
      <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:700px;position:relative;">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
          <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">{{ isEditMode ? '编辑表具' : '新增表具' }}</span>
          <button @click="closeAddForm" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
        </div>
        <!-- <div style="margin-bottom:24px;padding:12px 16px;background:#f5f5f5;border-radius:6px;color:#666;font-size:14px;">
          <span style="color:#e74c3c;">*</span> 为必填字段，请确保信息完整准        </div> -->
        <form class="edit-form">
          <div class="edit-form-row">
            <label><span class="required">*</span>设备名称</label>
            <input v-model="form.deviceName" class="form-input" placeholder="请输入设备名称" />
          </div>
          <div class="edit-form-row">
            <label>设备编号</label>
            <input v-model="form.deviceNumber" class="form-input" placeholder="请输入设备编号" />
            <span style="margin-left:8px;color:#999;font-size:12px;">（留空将自动生成)</span>
          </div>
          <div class="edit-form-row">
            <label>表具类型</label>
            <select v-model="form.meterType" class="form-input">
              <option value="">请选择表具类型</option>
              <option value="温湿度表">温湿度表</option>
              <option value="压力表">压力表</option>
            </select>
            <span style="margin-left:8px;color:#999;font-size:12px;">（当前：{{ activeTab }}</span>
          </div>
          <div class="edit-form-row">
            <label><span class="required">*</span>厂区</label>
            <input v-model="form.park" class="form-input" placeholder="请输入厂区" />
          </div>
          <div class="edit-form-row">
            <label><span class="required">*</span>楼号</label>
            <input v-model="form.building" class="form-input" placeholder="请输入楼号" />
          </div>
          <div class="edit-form-row">
            <label><span class="required">*</span>楼层</label>
            <input v-model="form.floor" class="form-input" placeholder="请输入楼层" />
          </div>
          <div class="edit-form-row">
            <label><span class="required">*</span>详细位置</label>
            <input v-model="form.detailLocation" class="form-input" placeholder="请输入详细位置" />
          </div>
          <div class="edit-form-row">
            <label><span class="required">*</span>生产厂家</label>
            <input v-model="form.manufacturer" class="form-input" placeholder="请输入生产厂家" />
          </div>
          <div class="edit-form-row">
            <label><span class="required">*</span>所属公司：</label>
            <input v-model="form.ownership" class="form-input" placeholder="请输入所属公司" />
          </div>
          <!-- <div class="edit-form-row">
            <label><span class="required">*</span>设备型号</label>
            <input v-model="form.model" class="form-input" placeholder="请输入设备型号" />
          </div> -->
          <div class="edit-form-row">
            <label><span class="required">*</span>安装日期</label>
            <input v-model="form.installDate" type="datetime-local" class="form-input" placeholder="1970-01-01T00:00:00Z" />
          </div>
          <div style="display:flex;justify-content:center;margin-top:32px;gap:16px;">
            <button type="button" class="search-btn-green" @click="onSubmit">保存</button>

          </div>
        </form>
      </div>
    </div>
    
    <!-- 详情弹窗 -->
    <div v-if="showDetailForm" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
      <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:700px;position:relative;">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
          <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">表具详情</span>
          <button @click="closeDetailForm" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
        </div>
        <div class="edit-form">
          <div class="edit-form-row">
            <label>设备名称</label>
            <input :value="form.deviceName" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>设备编号</label>
            <input :value="form.deviceNumber" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>表具类型</label>
            <input :value="form.meterType" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>厂区</label>
            <input :value="form.park" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>楼号</label>
            <input :value="form.building" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>楼层</label>
            <input :value="form.floor" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>详细位置</label>
            <input :value="form.detailLocation" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>生产厂家</label>
            <input :value="form.manufacturer" class="form-input" readonly />
          </div>
          <div class="edit-form-row">
            <label>所属公司：</label>
            <input :value="form.ownership" class="form-input" readonly />
          </div>
          <!-- <div class="edit-form-row">
            <label>设备型号</label>
            <input :value="form.model" class="form-input" readonly />
          </div> -->
          <div class="edit-form-row">
            <label>安装日期</label>
            <input :value="form.installDate" class="form-input" readonly />
          </div>
        </div>
 
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP_CONFIG } from '@/config/config.js'

export default {
  name: 'EnvMeter',
  data() {
    return {
      tabs: [
        { label: '温湿度表' },
        { label: '压力表' }
      ],
      activeTab: '温湿度表',
      query: {
        park: '',
        building: '',
        floor: '',
        company: '',
        startDate: '',
        endDate: '',
        fac_id: ''
      },
      page: 1,
      pageSize: 10,
      pageInput: '1',
      total: 0,
      totalPages: 1,
      showAddForm: false,
      form: {
        deviceName: '',
        deviceNumber: '',
        meterType: '',
        park: '',
        building: '',
        floor: '',
        detailLocation: '',
        manufacturer: '',
        ownership: '',
        model: '',
        installDate: ''
      },
      meterList: [],
      pressureList: [],
      loading: false,
      // 动态选项数组
      options: {
        park: [],
        building: [],
        floor: [],
        company: []
      },
      lastQuery: null, // 用于存储上一次的查询条件，以便判断是否需要更新选项
      showDetailForm: false, // 新增：控制详情弹窗的显示
      isEditMode: false // 新增：控制新增/编辑弹窗的编辑模式
    };
  },
  computed: {
    currentList() {
      return this.activeTab === '温湿度表' ? this.meterList : this.pressureList;
    },
    pagedList() {
      // 直接返回当前列表，因为已经是分页后的数据
      return this.currentList;
    },
    
    // 新增：生成显示的页码范围，最多显示10页
    displayPages() {
      const total = this.totalPages;
      const current = this.page;
      const maxDisplay = 10;
      
      if (total <= maxDisplay) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      
      let start = Math.max(1, current - Math.floor(maxDisplay / 2));
      let end = Math.min(total, start + maxDisplay - 1);
      
      if (end - start + 1 < maxDisplay) {
        start = Math.max(1, end - maxDisplay + 1);
      }
      
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    }
  },
  watch: {
    // 监听筛选条件变化，更新相关选项
    'query.park'() {
      this.updateOptions();
    },
    'query.building'() {
      this.updateOptions();
    },
    'query.floor'() {
      this.updateOptions();
    },
    'activeTab'() {
      this.updateOptions();
    }
  },
  mounted() {
    this.loadData();
    this.fetchOptions();
    // 设置默认安装日期为当前时间
    const now = new Date();
    this.form.installDate = now.toISOString().slice(0, 16);
    const BeijingTime2 = new Date(new Date() + 8 * 3600 * 1000);
    // const year = BeijingTime2.getFullYear()
    this.query.startDate = "2025" + "-01-01T00:00";
    this.query.endDate = BeijingTime2.toISOString().slice(0, 16);
  },
  methods: {
    // 获取所有选项数据
    async fetchOptions() {
      try {
        await Promise.all([
          this.fetchParkOptions(),
          this.fetchBuildingOptions(),
          this.fetchFloorOptions(),
          this.fetchCompanyOptions()
        ]);
      } catch (error) {
        console.error('获取选项数据失败:', error);
      }
    },

    // 获取厂区选项
    async fetchParkOptions() {
      try {
        const params = {};
        if (this.activeTab === '温湿度表') {
          params.fac_type = '0';
        } else if (this.activeTab === '压力表') {
          params.fac_type = '1';
        }
        if (this.query.building) params.building_number = this.query.building;
        if (this.query.floor) params.floor = this.query.floor;
        
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_fac_area_list/?${new URLSearchParams(params)}`);
        const data = await response.json();
        
        if (data && data.factory_area) {
          this.options.park = Array.from(data.factory_area).filter(Boolean);
        }
      } catch (error) {
        console.error('获取厂区选项失败:', error);
      }
    },

    // 获取楼号选项
    async fetchBuildingOptions() {
      try {
        const params = {};
        if (this.activeTab === '温湿度表') {
          params.fac_type = '0';
        } else if (this.activeTab === '压力表') {
          params.fac_type = '1';
        }
        if (this.query.park) params.factory_area = this.query.park;
        if (this.query.floor) params.floor = this.query.floor;
        
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_building_number_list/?${new URLSearchParams(params)}`);
        const data = await response.json();
        
        if (data && data.building_number) {
          this.options.building = Array.from(data.building_number).filter(Boolean);
        }
      } catch (error) {
        console.error('获取楼号选项失败:', error);
      }
    },

    // 获取楼层选项
    async fetchFloorOptions() {
      try {
        const params = {};
        if (this.activeTab === '温湿度表') {
          params.fac_type = '0';
        } else if (this.activeTab === '压力表') {
          params.fac_type = '1';
        }
        if (this.query.park) params.factory_area = this.query.park;
        if (this.query.building) params.building_number = this.query.building;
        
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_floor_list/?${new URLSearchParams(params)}`);
        const data = await response.json();
        
        if (data && data.floor) {
          this.options.floor = Array.from(data.floor).filter(Boolean);
        }
      } catch (error) {
        console.error('获取楼层选项失败:', error);
      }
    },

    // 获取公司选项
    async fetchCompanyOptions() {
      try {
        const params = {};
        if (this.activeTab === '温湿度表') {
          params.fac_type = '0';
        } else if (this.activeTab === '压力表') {
          params.fac_type = '1';
        }
        if (this.query.park) params.factory_area = this.query.park;
        if (this.query.building) params.building_number = this.query.building;
        if (this.query.floor) params.floor = this.query.floor;
        
        // 这里可以根据实际API调整，如果没有专门的company接口，可以设置默认值
        this.options.company = ['天津光电通信技术有限公司'];
      } catch (error) {
        console.error('获取公司选项失败:', error);
      }
    },

    // 智能更新选项
    async updateOptions() {
      try {
        // 根据当前筛选条件，只更新相关的选项
        const promises = [];
        
        // 如果tab切换，需要更新所有相关选项
        if (this.activeTab !== this.lastQuery?.activeTab) {
          promises.push(
            this.fetchParkOptions(),
            this.fetchBuildingOptions(),
            this.fetchFloorOptions(),
            this.fetchCompanyOptions()
          );
        }
        // 如果厂区变化，需要更新楼号、楼层选项
        else if (this.query.park !== this.lastQuery?.park) {
          promises.push(
            this.fetchBuildingOptions(),
            this.fetchFloorOptions()
          );
        }
        // 如果楼号变化，需要更新楼层选项
        else if (this.query.building !== this.lastQuery?.building) {
          promises.push(this.fetchFloorOptions());
        }
        
        if (promises.length > 0) {
          await Promise.all(promises);
        }
        
        // 保存当前查询条件用于下次比较
        this.lastQuery = { 
          activeTab: this.activeTab,
          park: this.query.park,
          building: this.query.building,
          floor: this.query.floor
        };
      } catch (error) {
        console.error('更新选项失败:', error);
      }
    },

    async loadData() {
      this.loading = true;
      try {
        if (this.activeTab === '温湿度表') {
          await this.loadTempHumData();
        } else {
          await this.loadPressureData();
        }
      } catch (error) {
        console.error('加载数据失败:', error);
      } finally {
        this.loading = false;
      }
    },
    
    async loadTempHumData() {
      try {
        const params = this.buildQueryParams();
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_TempHum_point_message/?${params}`);
        const data = await response.json();
        
        if (data.status === 'success' || data.data) {
          this.meterList = data.data.map(item => ({
            id: item.fac_id,
            deviceNumber: item.fac_id,
            deviceName: item.fac_name || '未命名',
            installDate: item.install_date || '未知',
            installLocation: this.formatLocation(item),
            manufacturer: item.fac_factory || '未知',
            company: item.company || '未知',
            // 添加详细位置信息
            factory_area: item.factory_area || '',
            building_number: item.building_number || '',
            floor: item.floor || '',
            install_area: item.install_area || ''
          }));
          
          // 更新分页信息
          this.total = data.total || this.meterList.length;
          this.totalPages = data.total_pages || Math.max(1, Math.ceil(this.total / this.pageSize));
        }
      } catch (error) {
        console.error('加载温湿度表数据失败:', error);
        this.meterList = [];
        this.total = 0;
        this.totalPages = 1;
      }
    },
    
    async loadPressureData() {
      try {
        const params = this.buildQueryParams();
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/environment/query_pressure_point_message/?${params}`);
        const data = await response.json();
        
        if (data.status === 'success' || data.data) {
          this.pressureList = data.data.map(item => ({
            id: item.fac_id,
            deviceNumber: item.fac_id,
            deviceName: item.fac_name || '未命名',
            installDate: item.install_date || '未知',
            installLocation: this.formatLocation(item),
            manufacturer: item.fac_factory || '未知',
            company: item.company || '未知',
            // 添加详细位置信息
            factory_area: item.factory_area || '',
            building_number: item.building_number || '',
            floor: item.floor || '',
            install_area: item.install_area || ''
          }));
          
          // 更新分页信息
          this.total = data.total || this.pressureList.length;
          this.totalPages = data.total_pages || Math.max(1, Math.ceil(this.total / this.pageSize));
        }
      } catch (error) {
        console.error('加载压力表数据失败:', error);
        this.pressureList = [];
        this.total = 0;
        this.totalPages = 1;
      }
    },
    
    buildQueryParams() {
      const params = new URLSearchParams();
      
      if (this.query.park) {
        params.append('factory_area', this.query.park);
      }
      if (this.query.building) {
        params.append('building_number', this.query.building);
      }
      if (this.query.floor) {
        params.append('floor', this.query.floor);
      }
      if (this.query.company) {
        params.append('company', this.query.company);
      }
      if (this.query.startDate) {
        params.append('start_date', this.query.startDate.split('T')[0]);
      }
      if (this.query.endDate) {
        params.append('end_date', this.query.endDate.split('T')[0]);
      }
      if (this.query.fac_id) {
        params.append('fac_id', this.query.fac_id);
      }
      
      params.append('page', this.page);
      params.append('per_page', this.pageSize);
      
      return params.toString();
    },
    
    formatLocation(item) {
      const parts = [];
      if (item.factory_area) parts.push(item.factory_area);
      if (item.building_number) parts.push(item.building_number);
      if (item.floor) parts.push(item.floor);
      if (item.install_area) parts.push(item.install_area);
      
      return parts.length > 0 ? parts.join('') : '未知位置';
    },
    
    switchTab(tab) {
      this.activeTab = tab.label;
      this.page = 1;
      // 重置查询条件
      this.query.park = '';
      this.query.building = '';
      this.query.floor = '';
      this.query.company = '';
      this.loadData();
      this.updateOptions();
    },
    
    onSearch() {
      this.page = 1;
      this.loadData();
    },
    
    onRefresh() {
      this.loadData();
    },
    
    onClear() {
      this.query = {
        park: '',
        building: '',
        floor: '',
        company: '',
        startDate: '',
        endDate: '',
        fac_id: ''
      };
      this.page = 1;
      this.loadData();
      this.updateOptions();
    },
    
    jumpPage() {
      let p = parseInt(this.pageInput);
      if (!isNaN(p) && p >= 1 && p <= this.totalPages) {
        this.page = p;
        this.loadData();
      }
    },
    
    closeAddForm() {
      this.showAddForm = false;
      this.resetForm();
      this.isEditMode = false; // 关闭弹窗时重置编辑模式
    },
    
    resetForm() {
      this.form = {
        deviceName: '',
        deviceNumber: '',
        meterType: '',
        park: '',
        building: '',
        floor: '',
        detailLocation: '',
        manufacturer: '',
        ownership: '',
        model: '',
        installDate: ''
      };
    },
    
    // 新增：打印功能
    async printData() {
      try {
        console.log('=== 开始打印环境表具数据 ===');
        
        // 构建查询参数，设置per_page为500获取所有数据
        const params = this.buildPrintQueryParams();
        
        console.log('打印查询参数:', params);
        
        // 根据当前tab选择对应的接口
        const apiUrl = this.activeTab === '温湿度表' 
          ? `${HTTP_CONFIG.SERVER_ADDR}/environment/query_TempHum_point_message/`
          : `${HTTP_CONFIG.SERVER_ADDR}/environment/query_pressure_point_message/`;
        
        // 调用API获取所有数据
        const response = await fetch(`${apiUrl}?${params}`);
        const data = await response.json();
        
        let allData = [];
        
        if (data.status === 'success' || data.data) {
          allData = data.data.map(item => ({
            id: item.fac_id,
            deviceNumber: item.fac_id,
            deviceName: item.fac_name || '未命名',
            installDate: item.install_date || '未知',
            installLocation: this.formatLocation(item),
            manufacturer: item.fac_factory || '未知',
            company: item.company || '未知',
            factory_area: item.factory_area || '',
            building_number: item.building_number || '',
            floor: item.floor || '',
            install_area: item.install_area || ''
          }));
          
          console.log('API返回数据:', allData);
          console.log('数据数组长度:', allData.length);
        } else {
          console.error('获取打印数据失败:', data.message);
          allData = this.currentList;
        }

        // 生成打印内容
        const printContent = `
          <div style="padding: 20px;">
            <h2 style="text-align: center; margin-bottom: 20px;">${this.activeTab}管理列表</h2>
            <div style="margin-bottom: 10px; text-align: right; color: #666;">
              打印时间: ${new Date().toLocaleString('zh-CN')}
            </div>
            <div style="margin-bottom: 10px; text-align: right; color: #666;">
              总记录数: ${allData.length} 条
            </div>
            <div style="margin-bottom: 10px; text-align: left; color: #666;">
              查询条件: ${this.getQueryConditions()}
            </div>
            <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
              <thead>
                <tr style="background: #f5f5f5;">
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">序号</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备编号</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备名称</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">安装日期</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">安装位置</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备厂家</th>
                  <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">所属公司</th>
                </tr>
              </thead>
              <tbody>
                ${allData.map((item, index) => `
                  <tr>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${index + 1}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.deviceNumber}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.deviceName}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.installDate}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.installLocation}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.manufacturer}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.company}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          </div>
        `;
        
        // 打开打印窗口
        const printWindow = window.open('', '_blank');
        printWindow.document.write(printContent);
        printWindow.document.close();
        printWindow.print();
        printWindow.close();
        
        console.log('=== 环境表具打印完成 ===');
        
      } catch (error) {
        console.error('打印环境表具数据失败:', error);
        alert('打印失败，请查看控制台');
      }
    },
    
    // 构建打印查询参数
    buildPrintQueryParams() {
      const params = new URLSearchParams();
      
      if (this.query.park) {
        params.append('factory_area', this.query.park);
      }
      if (this.query.building) {
        params.append('building_number', this.query.building);
      }
      if (this.query.floor) {
        params.append('floor', this.query.floor);
      }
      if (this.query.company) {
        params.append('company', this.query.company);
      }
      if (this.query.startDate) {
        params.append('start_date', this.query.startDate.split('T')[0]);
      }
      if (this.query.endDate) {
        params.append('end_date', this.query.endDate.split('T')[0]);
      }
      if (this.query.fac_id) {
        params.append('fac_id', this.query.fac_id);
      }
      
      // 设置分页参数获取所有数据
      params.append('page', 1);
      params.append('per_page', 500); // 设置每页500条数据
      
      return params.toString();
    },
    
    // 获取查询条件描述
    getQueryConditions() {
      const conditions = [];
      if (this.query.park) conditions.push(`厂区: ${this.query.park}`);
      if (this.query.building) conditions.push(`楼号: ${this.query.building}`);
      if (this.query.floor) conditions.push(`楼层: ${this.query.floor}`);
      if (this.query.fac_id) conditions.push(`设备编号: ${this.query.fac_id}`);
      if (this.query.startDate) conditions.push(`开始日期: ${this.query.startDate.split('T')[0]}`);
      if (this.query.endDate) conditions.push(`结束日期: ${this.query.endDate.split('T')[0]}`);
      
      return conditions.length > 0 ? conditions.join(', ') : '全部';
    },
    
    async onSubmit() {
      // 验证必填字段
      if (!this.form.deviceName) {
        alert('请输入设备名称');
        return;
      }
      if (!this.form.park) {
        alert('请选择厂区');
        return;
      }
      if (!this.form.building) {
        alert('请选择楼号');
        return;
      }
      if (!this.form.floor) {
        alert('请选择楼层');
        return;
      }
      if (!this.form.detailLocation) {
        alert('请输入详细位置');
        return;
      }
      if (!this.form.manufacturer) {
        alert('请输入生产厂家');
        return;
      }
      if (!this.form.ownership) {
        alert('请选择所属公司');
        return;
      }
      // if (!this.form.model) {
      //   alert('请输入设备型号');
      //   return;
      // }
      if (!this.form.installDate) {
        alert('请选择安装日期');
        return;
      }
      
      // 验证日期格式
      const installDate = new Date(this.form.installDate);
      if (isNaN(installDate.getTime())) {
        alert('安装日期格式不正确');
        return;
      }
      
      // 验证日期不能是未来时间
      if (installDate > new Date()) {
        alert('安装日期不能是未来时间');
        return;
      }
      
      // 验证字符串长度
      if (this.form.deviceName.length > 100) {
        alert('设备名称不能超过100个字符');
        return;
      }
      if (this.form.detailLocation.length > 200) {
        alert('详细位置不能超过200个字符');
        return;
      }
      if (this.form.manufacturer.length > 100) {
        alert('生产厂家不能超过100个字符');
        return;
      }
      // if (this.form.model.length > 100) {
      //   alert('设备型号不能超过100个字符');
      //   return;
      // }
      
      let submitButton;
      let originalText;
      
      try {
        // 显示加载状态
        submitButton = event.target;
        originalText = submitButton.textContent;
        submitButton.textContent = '提交..';
        submitButton.disabled = true;
        
        // 构建提交数据，确保数据格式正确
        const submitData = {
          fac_id: (this.form.deviceNumber || this.generateDeviceId()).toString().trim(),
          fac_name: this.form.deviceName.toString().trim(),
          factory_area: this.form.park.toString().trim(),
          building_number: this.form.building.toString().trim(),
          floor: this.form.floor.toString().trim(),
          install_area: this.form.detailLocation.toString().trim(),
          install_date: this.form.installDate,
          fac_factory: this.form.manufacturer.toString().trim(),
          company: this.form.ownership.toString().trim()
        };
        
        // 如果是编辑模式，添加编辑标识
        if (this.isEditMode) {
          submitData.is_edit = true;
          submitData.original_fac_id = this.form.deviceNumber; // 保存原始设备ID
        }
        
        // 根据当前tab选择对应的接口
        const apiUrl = this.activeTab === '温湿度表' 
          ? `${HTTP_CONFIG.SERVER_ADDR}/environment/create_TempHum_point_message/`
          : `${HTTP_CONFIG.SERVER_ADDR}/environment/create_pressure_point_message/`;
        
        // 记录提交信息（开发调试用）
        console.log('提交数据:', submitData);
        console.log('请求URL:', apiUrl);
        console.log('编辑模式:', this.isEditMode);
        
        // 使用 URLSearchParams 构造数据包
        const formData = new URLSearchParams();
        
        // 遍历数据并添加到表单中，过滤空值
        for (const [key, value] of Object.entries(submitData)) {
          if (value !== '' && value !== null && value !== undefined) {
            // 确保所有值都转换为字符串
            const stringValue = String(value).trim();
            if (stringValue !== '') {
              formData.append(key, stringValue);
            }
          }
        }
        
        console.log('FormData 内容:', formData.toString());
        console.log('FormData 键值对:');
        for (const [key, value] of formData.entries()) {
          console.log(`${key}: ${value}`);
        }
        
        // 发送请求
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: formData
        });
        
        console.log('响应状态:', response.status);
        console.log('响应状态文本:', response.statusText);
        console.log('响应:', Object.fromEntries(response.headers.entries()));
        
        // 处理响应
        let result;
        const contentType = response.headers.get('content-type');
        
        if (contentType && contentType.includes('application/json')) {
          try {
            result = await response.json();
            console.log('JSON响应数据:', result);
          } catch (parseError) {
            console.error('JSON解析失败:', parseError);
            throw new Error('服务器响应格式错误，无法解析JSON数据');
          }
        } else {
          // 如果不是JSON，尝试获取文本
          const textResult = await response.text();
          console.log('文本响应:', textResult);
          
          // 尝试解析为JSON（有些接口可能没有设置正确的content-type）
          try {
            result = JSON.parse(textResult);
            console.log('解析后的响应数据:', result);
          } catch (parseError) {
            console.error('文本解析为JSON失败:', parseError);
            // 如果无法解析，检查是否包含成功关键词
            if (textResult.toLowerCase().includes('success') || textResult.includes('成功')) {
              result = { status: 'success', message: '操作成功' };
            } else {
              throw new Error(`服务器响应: ${textResult}`);
            }
          }
        }
        
        // 判断操作是否成功
        const isSuccess = response.ok && (
          result.status === 'success' || 
          result.message === 'success' || 
          result.code === 200 || 
          result.code === '200' ||
          result.msg === 'success' ||
          result.msg === '成功'
        );
        
        if (isSuccess) {
          const action = this.isEditMode ? '编辑' : '新增';
          const meterType = this.activeTab;
          alert(`${meterType}信息${action}成功！\n设备名称:${this.form.deviceName}\n设备编号:${submitData.fac_id}`);
          this.closeAddForm();
          // 刷新数据列表
          this.loadData();
        } else {
          // 处理失败情况
          let errorMessage = '操作失败';
          
          if (result.message) {
            errorMessage = result.message;
          } else if (result.error) {
            errorMessage = result.error;
          } else if (result.detail) {
            errorMessage = result.detail;
          } else if (result.msg) {
            errorMessage = result.msg;
          } else if (result.reason) {
            errorMessage = result.reason;
          } else if (response.status === 400) {
            errorMessage = '请求参数错误，请检查输入信息';
          } else if (response.status === 401) {
            errorMessage = '未授权访问，请检查权限';
          } else if (response.status === 403) {
            errorMessage = '禁止访问，请检查权限';
          } else if (response.status === 404) {
            errorMessage = '接口不存在，请检查URL';
          } else if (response.status === 500) {
            errorMessage = '服务器内部错误，请稍后重试';
          } else if (response.status === 502) {
            errorMessage = '网关错误，请稍后重试';
          } else if (response.status === 503) {
            errorMessage = '服务不可用，请稍后重试';
          } else if (response.status === 0) {
            errorMessage = '网络连接失败，请检查网络';
          } else {
            errorMessage = `请求失败 (${response.status}): ${response.statusText || '未知错误'}`;
          }
          
          throw new Error(errorMessage);
        }
        
      } catch (error) {
        console.error('提交失败:', error);
        console.error('错误详情:', {
          name: error.name,
          message: error.message,
          stack: error.stack
        });
        alert(`操作失败: ${error.message}`);
      } finally {
        // 恢复按钮状态
        if (submitButton && originalText) {
          submitButton.textContent = originalText;
          submitButton.disabled = false;
        }
      }
    },
    
    // 生成设备ID的辅助方法
    generateDeviceId() {
      const timestamp = Date.now();
      const random = Math.floor(Math.random() * 1000);
      return `DEV_${timestamp}_${random}`;
    },

    showDeviceDetail(item) {
      console.log('查看详情:', item);
      // 将当前行数据填充到详情弹窗，确保字段映射正确
      this.form = {
        deviceName: item.deviceName || item.fac_name || '',
        deviceNumber: item.deviceNumber || item.fac_id || '',
        meterType: item.meterType || (this.activeTab === '温湿度表' ? '温湿度表' : '压力表'),
        park: item.park || item.factory_area || '',
        building: item.building || item.building_number || '',
        floor: item.floor || '',
        detailLocation: item.detailLocation || item.install_area || '',
        manufacturer: item.manufacturer || item.fac_factory || '',
        ownership: item.ownership || item.company || '',
        model: item.model || '',
        installDate: item.installDate || item.install_date || ''
      };
      console.log('详情弹窗表单数据:', this.form);
      this.showDetailForm = true;
    },

    showDeviceEdit(item) {
      console.log('编辑设备:', item);
      // 将当前行数据填充到表单，确保字段映射正确
      this.form = {
        deviceName: item.deviceName || item.fac_name || '',
        deviceNumber: item.deviceNumber || item.fac_id || '',
        meterType: item.meterType || (this.activeTab === '温湿度表' ? '温湿度表' : '压力表'),
        park: item.park || item.factory_area || '',
        building: item.building || item.building_number || '',
        floor: item.floor || '',
        detailLocation: item.detailLocation || item.install_area || '',
        manufacturer: item.manufacturer || item.fac_factory || '',
        ownership: item.ownership || item.company || '',
        model: item.model || '',
        installDate: item.installDate || item.install_date || ''
      };
      console.log('编辑弹窗表单数据:', this.form);
      this.showAddForm = true;
      // 修改弹窗标题为编辑模          this.isEditMode = true;
    },
    
    // 新增表具时自动设置默认值
    showAddFormWithDefaults() {
      this.isEditMode = false;
      this.resetForm();
      // 自动设置表具类型为当前tab
      this.form.meterType = this.activeTab;
      // 设置默认安装日期为当前时间
      const now = new Date();
      this.form.installDate = now.toISOString().slice(0, 16);
      this.showAddForm = true;
    },

    closeDetailForm() {
      this.showDetailForm = false;
      this.form = {
        deviceName: '',
        deviceNumber: '',
        meterType: '',
        park: '',
        building: '',
        floor: '',
        detailLocation: '',
        manufacturer: '',
        ownership: '',
        model: '',
        installDate: ''
      };
    }
  }
}
</script>

<style scoped>
.loading {
  text-align: center;
  padding: 20px;
  color: #666;
}

.form-input {
  width: 200px;
  min-width: 200px;
}

.loading::before {
  content: " ";
  margin-right: 8px;
}

/* 弹窗样式 */
.edit-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.edit-form-row {
  display: flex;
  align-items: center;
}

.edit-form-row label {
  color: #222;
  font-size: 16px;
  min-width: 120px;
  text-align: right;
  margin-right: 12px;
}

.edit-form-row .form-input {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 15px;
  min-width: 200px;
  outline: none;
  transition: border 0.2s;
}

.edit-form-row .form-input:focus {
  border: 1.5px solid #4caf50;
}

.edit-form-row select.form-input {
  min-width: 200px;
}

.edit-form-row input[type="datetime-local"].form-input {
  min-width: 200px;
}

.required {
  color: #e74c3c;
  margin-right: 4px;
}

/* 弹窗内容区域样式 */
.modal-content {
  max-height: 80vh;
  overflow-y: auto;
}

/* 响应式设*/
@media (max-width: 768px) {
  .edit-form-row {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .edit-form-row label {
    min-width: auto;
    margin-bottom: 8px;
  }
  
  .edit-form-row .form-input {
    min-width: 100%;
  }
}

/* 清空按钮样式 */
.clear-btn {
  background: #f5f5f5;
  color: #666;
  border: 1px solid #ddd;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 8px;
  transition: all 0.2s;
}

.clear-btn:hover {
  background: #e8e8e8;
  border-color: #ccc;
}
</style>
